import React from "react";

interface ContentWrapperFaqProps {
  children: React.ReactNode;
  showTopBorder?: boolean;
}

const ContentWrapperFaq: React.FC<ContentWrapperFaqProps> = ({
  children,
  showTopBorder = true
}) => {
  return (
    <div className="tw-root w-full flex flex-col relative mx-0 overflow-x-hidden">
      {/* Top border */}
      <div
        className={`w-auto md:w-full md:container ${
          showTopBorder ? "border-l border-r border-border h-4 md:h-44" : "h-1"
        } mx-5 md:mx-auto relative`}
      >
        {/* Top-left corner icon */}
        <img
          src="/hire/plan-selection-plus.svg"
          width={10}
          height={11}
          className="absolute left-0 top-full -translate-x-1/2 -translate-y-1/2 z-10"
        />
        {/* Top-right corner icon */}
        <img
          src="/hire/plan-selection-plus.svg"
          width={10}
          height={11}
          className="absolute right-0 top-full translate-x-1/2 -translate-y-1/2 z-10"
        />
      </div>

      {/* Middle content area */}
      <div className="border-b border-t border-border relative w-full">
        <div className="w-auto md:w-full md:container border-l border-r border-border mx-5 md:mx-auto">
          {children}
        </div>
      </div>

      {/* Bottom border */}
      <div
        className={`w-auto md:w-full md:container border-l border-r border-border h-11 mx-5 md:mx-auto relative`}
      >
        {/* Bottom-left corner icon */}
        <img
          src="/hire/plan-selection-plus.svg"
          width={10}
          height={11}
          className="absolute left-0 top-0 -translate-x-1/2 -translate-y-1/2 z-10"
        />
        {/* Bottom-right corner icon */}
        <img
          src="/hire/plan-selection-plus.svg"
          width={10}
          height={11}
          className="absolute right-0 top-0 translate-x-1/2 -translate-y-1/2 z-10"
        />
      </div>
    </div>
  );
};

export default ContentWrapperFaq;
